import { scrollToId } from "@/lib/smooth";

const navLinks = [
  { label: "About", href: "#about" },
  { label: "Nisha", href: "#nisha" },
  { label: "Offerings", href: "#offerings" },
  { label: "Retreats", href: "#retreats" },
  { label: "FAQ", href: "#faq" },
];

export const Footer = () => {
  return (
    <footer data-testid="footer" className="bg-[#1A1A1A] text-[#FAF7F2] pt-20 pb-8">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <div className="flex flex-col min-[900px]:flex-row justify-between gap-12">
          {/* Left */}
          <div className="max-w-sm">
            <div className="flex items-center gap-3">
              <img src="/images/logo.png" alt="Pause." className="h-16 w-16 object-contain" />
              <span className="font-display text-3xl">Pause<span className="text-[#F5C800]">.</span></span>
            </div>
            <p className="mt-6 font-body text-[#FAF7F2]/60 leading-relaxed">
              A quiet mind. An agile body. Yoga, breathwork, and off-grid retreats with Nisha.
            </p>
            <a
              data-testid="footer-instagram"
              href="https://instagram.com/breathe.pause.connect"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-6 inline-block font-body text-sm uppercase tracking-[0.14em] text-[#F5C800] hover:opacity-70 transition-opacity duration-300"
            >
              @breathe.pause.connect →
            </a>
          </div>

          {/* Right */}
          <div className="flex flex-col gap-4">
            <span className="font-body text-xs uppercase tracking-[0.22em] text-[#FAF7F2]/40 mb-1">Explore</span>
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={(e) => {
                  e.preventDefault();
                  scrollToId(l.href);
                }}
                data-testid={`footer-link-${l.label.toLowerCase()}`}
                className="font-body text-lg text-[#FAF7F2]/80 hover:text-[#F5C800] transition-colors duration-300 w-fit"
              >
                {l.label}
              </a>
            ))}
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-[#FAF7F2]/10 flex flex-col sm:flex-row justify-between gap-3 font-body text-xs uppercase tracking-[0.14em] text-[#FAF7F2]/40">
          <span>© {new Date().getFullYear()} Pause. All rights reserved.</span>
          <span>Made with breath &amp; patience.</span>
        </div>
      </div>
    </footer>
  );
};
